import React from "react";
import HypenaNav from "../common/HypenaNav";
import HypenaFooter from "../common/HypenaFooter";
import HomePage from "../pages/home/HomePage";

const MainLayout = () => (
  <div className="hypena-page-wrap">
    <HypenaNav />
    <HomePage />
    <HypenaFooter />
  </div>
);

export default MainLayout;
